//Auth layout

const state = {
    authLayoutSideMenuShow: true //Состояние бокового меню для sideMenuItem
};

const getters = {
    authLayoutSideMenuShow: state => {
        return state.authLayoutSideMenuShow
    }
};

const mutations = {
    authLayoutSideMenuShow: (state, payload) => {
        return state.authLayoutSideMenuShow = payload
    }
};

const actions = {
    authLayoutSideMenuShow({commit}, sideMenuStatus) {
        return commit('authLayoutSideMenuShow', sideMenuStatus)
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}